import { chakra } from "@chakra-ui/react";

// Pill-shaped action buttons shared by the modal dialogs: a filled brand
// primary action and an outlined secondary (cancel/back) action.
export function PrimaryButton({
  children,
  disabled,
  onClick,
  type = "button",
  flex,
}: {
  children: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
  type?: "button" | "submit";
  flex?: number | string;
}) {
  return (
    <chakra.button
      type={type}
      onClick={onClick}
      disabled={disabled}
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      gap="2"
      bg={disabled ? "bg.subtle" : "bg.brand"}
      color={disabled ? "fg.muted" : "fg.onBrand"}
      border="0"
      borderRadius="pill"
      minH="48px"
      py="3"
      px="6"
      fontWeight="bold"
      fontSize="14px"
      lineHeight="1"
      cursor={disabled ? "not-allowed" : "pointer"}
      flex={flex}
      boxShadow={disabled ? "none" : "brandGlow"}
      _hover={!disabled ? { filter: "brightness(1.04)" } : undefined}
    >
      {children}
    </chakra.button>
  );
}

export function GhostButton({
  children,
  disabled,
  onClick,
  flex,
}: {
  children: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
  flex?: number | string;
}) {
  return (
    <chakra.button
      type="button"
      onClick={onClick}
      disabled={disabled}
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      bg="transparent"
      color="fg.muted"
      border="1px solid"
      borderColor="border.default"
      borderRadius="pill"
      minH="48px"
      py="3"
      px="5"
      fontWeight="semibold"
      fontSize="14px"
      lineHeight="1"
      cursor={disabled ? "not-allowed" : "pointer"}
      flex={flex}
      _hover={!disabled ? { bg: "bg.subtle" } : undefined}
    >
      {children}
    </chakra.button>
  );
}
